import { api } from "./api";

let _count = null;
let _pending = null;

export function fetchOffersCount() {
  if (_count !== null) return Promise.resolve(_count);
  if (_pending) return _pending;
  _pending = api.get("/coupons/public")
    .then((r) => { _count = (r.data || []).length; _pending = null; return _count; })
    .catch(() => { _count = 0; _pending = null; return 0; });
  return _pending;
}
